
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";

const ConnectionErrorAlert = () => {
  // Hide the connection error alert completely
  return null;
};

export default ConnectionErrorAlert;
